import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ChatHeader from '@rsos/components/capstone/Chat/ChatHeader';
import { ChatParticipant } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';
import { RootState } from '../../../../app';
import TalkJSChatbox from '../../../TalkJSChatbox/TalkJSChatbox';
import { useChatComponents } from '../../useChatComponents';
import { useChatContext } from '../ChatContext';
import {
  ChatBoxContainer,
  Container,
  CHAT_HEADER_HEIGHT,
  ChatWrapper,
} from './ASCChatBox.styles';

const AgencyShareChatBox = () => {
  const [callChatParticipants, setCallChatParticipants] = useState<
    ChatParticipant[]
  >([]);
  const { collapse, isCollapsed } = useChatContext();
  const currentPSAP = useSelector(
    (state: RootState) => state.psaps.currentPSAP,
  );
  const callerID = useSelector(
    (state: RootState) => state.emergencyCalls.selectedCallerID,
  );
  const currentCall = useSelector((state: RootState) =>
    callerID ? state.emergencyCalls.callQueue[callerID] : undefined,
  );
  const { bothChatsEnabled } = useChatComponents();
  // For 911 calls, backend is sending back the full list of chat participants,
  // frontend has to filter out the current PSAP from the list due to design.
  // The list of chat participants can change as agencies join/leave the conversation.
  useEffect(() => {
    if (currentCall?.agencyShareChat?.chatParticipants) {
      const filteredChatParticipants =
        currentCall.agencyShareChat.chatParticipants.filter(
          participant => participant.account_id !== currentPSAP.account_id,
        );
      setCallChatParticipants(filteredChatParticipants);
    }
  }, [currentCall, currentPSAP.account_id]);

  const chatHeight = useMemo(() => {
    if (!isCollapsed) {
      if (bothChatsEnabled) {
        return '50%';
      }
      return '100%';
    }
    return '100%';
  }, [isCollapsed, bothChatsEnabled]);

  return (
    <Container
      height={chatHeight}
      maxHeight={isCollapsed ? CHAT_HEADER_HEIGHT : '100%'}
      flex={isCollapsed ? '0 0 auto' : '1 1 auto'}
    >
      <ChatWrapper>
        <ChatHeader
          callChatParticipants={callChatParticipants}
          isChatBoxVisible={!isCollapsed}
          isUnread={currentCall?.agencyShareChat?.isUnread ?? false}
          onActionButtonClick={() => collapse?.(!isCollapsed)}
        />
        <ChatBoxContainer data-name="ChatBoxContainer">
          <TalkJSChatbox />
        </ChatBoxContainer>
      </ChatWrapper>
    </Container>
  );
};

export default AgencyShareChatBox;
